import React from 'react';
import { gallery } from '../../data/gallery';
export function Gallery() {
  return <section id="gallery" className="bg-white py-20 md:py-28" data-id="element-54" data-mp="v760yi3wfsbq">
      <div className="mx-auto max-w-7xl px-6" data-id="element-55" data-mp="v4tnoi936650">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-56" data-mp="18yugkvdcwyxg">
          <div className="max-w-2xl" data-id="element-57" data-mp="14wzazeoe7zdv">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-58" data-mp="14y0t233ttm53">
              Photo gallery
            </p>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-59" data-mp="h8zo4pu7ct4k">
              Recent work across the Front Range
            </h2>
          </div>
          <a href="#quote" className="flex-none text-sm font-semibold text-brand underline-offset-4 hover:underline" data-id="element-60" data-mp="q5gr35sexkp8">
            Start a project like these →
          </a>
        </div>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-61" data-mp="1wo5g69iz0na0">
          {gallery.map((item, i) => <li key={item.src} className={['group relative overflow-hidden rounded-2xl bg-ink', i === 0 ? 'sm:col-span-2 sm:row-span-2' : ''].join(' ')} data-id="element-62" data-mp="3b7xc2gdxyhjg" data-mpi={i}>
              <img src={item.src} alt={item.alt} className={['w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]', i === 0 ? 'h-64 sm:h-full sm:min-h-[26rem]' : 'h-64'].join(' ')} data-id="element-63" data-mp="3k8n2t5ochhqb" />
              <div className="absolute inset-x-0 bottom-0 h-1/2 bg-[linear-gradient(to_top,rgba(23,20,15,0.85),transparent)]" aria-hidden="true" data-id="element-64" data-mp="31hcgl1tkdt4r" />
              <div className="absolute inset-x-0 bottom-0 p-5" data-id="element-65" data-mp="369vww6jmz2d9">
                <p className="font-heading text-base font-semibold text-white" data-id="element-66" data-mp="28s5j865uj9l3">
                  {item.caption}
                </p>
                <p className="mt-0.5 text-sm text-white/70" data-id="element-67" data-mp="2dpf6bf5rj95r">{item.location}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}